export class Breadcrumb {
  label: string;
  path: string;

  constructor(label, path) {
    this.label = label;
    this.path = path;
  }
}
